/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {
    readonly action: PortfolioItemsAction;
    readonly endPortfolioItemId?: string | null;
    readonly itemsIds?: ReadonlyArray<string | null> | null;
    readonly note?: string | null;
    readonly portfolioItemsIds?: ReadonlyArray<string | null> | null;
    readonly portfolioId?: string | null;
    readonly portfolioType?: PortfolioType | null;
    readonly startPortfolioItemId?: string | null;
    readonly targetPortfolioItemId?: string | null;
    readonly userId: string;
    readonly clientMutationId?: string | null;
};
export type ModifyPortfolioItemsMutationVariables = {
    readonly input: ModifyPortfolioItemsInput;
};
export type ModifyPortfolioItemsMutationResponse = {
    readonly modifyPortfolioItems: {
        readonly portfolio: {
            readonly id: string;
        } | null;
    } | null;
};
export type ModifyPortfolioItemsMutation = {
    readonly response: ModifyPortfolioItemsMutationResponse;
    readonly variables: ModifyPortfolioItemsMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "ModifyPortfolioItemsInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "modifyPortfolioItems",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ModifyPortfolioItemsPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "portfolio",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ModifyPortfolioItemsMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "ModifyPortfolioItemsMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "ModifyPortfolioItemsMutation",
            "id": "app-buyer-misc/234.0.0-2019-09-26T08:41:36.086Z/ModifyPortfolioItemsMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '94aed0469fe8b3138bef1ac19d488d29';
export default node;
